import React, { useMemo } from 'react';
import InputComponent from '@ui/components/Input/Input.component';
import ModalComponent from '@ui/components/Modal/Modal.component';
import ButtonComponent from '@ui/components/Button/Button.component';
import ButtonBarComponent from '@ui/components/Button-bar/Button-bar.component';
import ModalFormComponent from '@ui/components/Modal-form/Modal-form.component';
import SendAgainComponent from '@ui/components/Send-again/Send-again.component';
import { IProps } from './IProps';

const Component: React.FC<IProps> = ({
    lang,
    loading,
    code,
    codeError,
    confirmError,
    serverError,
    password,
    passwordConfirm,
    passwordError,
    passwordConfirmError,
    sendedAgain,
    timeToRequestAgain,
    isAllowedToRequestAgain,
    onCodeChange,
    onPasswordChange,
    onPasswordConfirmChange,
    onConfirmClick,
    onRequestConfirmClick,
    onInputClick,
    onBackClick,
    onKeyDown,
    onBtnKeyDown,
    onClose,
}: IProps) => {
    const alertMessage = useMemo(() => {
        if (serverError) return 'serverError';
        else if (sendedAgain) return 'confirmationHasBeenSendedAgain';
        else return '';
    }, [serverError, sendedAgain]);

    const errorMessage = useMemo(() => {
        if (codeError) return 'inputConfirmationCode';
        else if (confirmError) return 'wrongConfirm';
        else return '';
    }, [codeError, confirmError]);

    return (
        <ModalComponent
            className="password-confirm"
            title="passwordRecovery"
            alert={sendedAgain ? 'success' : 'error'}
            alertText={alertMessage}
            lang={lang}
            loading={loading}
            onBtnKeyDown={onBtnKeyDown}
            onBackClick={onBackClick}
            onClose={onClose}
        >
            <SendAgainComponent
                lang={lang}
                text="timerText"
                time={timeToRequestAgain}
            />
            <ModalFormComponent>
                <InputComponent
                    label="password"
                    name="password"
                    type="password"
                    helperText="passwordAlertMessage"
                    errorMessage="passwordAlertMessage"
                    lang={lang}
                    value={password}
                    error={passwordError}
                    onChange={onPasswordChange}
                    onClick={onInputClick}
                    onFocus={onInputClick}
                    onKeyDown={onKeyDown}
                />
                <InputComponent
                    label="passwordConfirm"
                    name="password-confirm"
                    type="password"
                    errorMessage="passwordConfirmAlertMessage"
                    lang={lang}
                    value={passwordConfirm}
                    error={passwordConfirmError}
                    onChange={onPasswordConfirmChange}
                    onClick={onInputClick}
                    onFocus={onInputClick}
                    onKeyDown={onKeyDown}
                />
                <InputComponent
                    label="confirmationCode"
                    name="confirmation-code"
                    type="text"
                    errorMessage={errorMessage}
                    lang={lang}
                    value={code}
                    error={!!errorMessage}
                    onChange={onCodeChange}
                    onClick={onInputClick}
                    onFocus={onInputClick}
                    onKeyDown={onKeyDown}
                />
            </ModalFormComponent>
            <ButtonBarComponent>
                <ButtonComponent
                    label="confirm"
                    lang={lang}
                    onClick={onConfirmClick}
                    onKeyDown={onBtnKeyDown}
                />
                <ButtonComponent
                    color="warning"
                    label="requestAgain"
                    lang={lang}
                    disabled={!isAllowedToRequestAgain}
                    onClick={onRequestConfirmClick}
                    onKeyDown={onBtnKeyDown}
                />
            </ButtonBarComponent>
        </ModalComponent>
    );
};

const PasswordConfirmComponent = React.memo(Component);

export default PasswordConfirmComponent;
